import { SITE_URL } from '@/lib/seo';
import BRAND from '@/config/brand';
import { useLanguage } from '@/contexts/LanguageContextNew';
import { useSchemaDOM } from '@/hooks/useSchemaDOM';

interface EnhancedServiceSchemaProps {
  serviceName: string; serviceDescription: string; serviceSlug: string;
  category: 'bpo' | 'digital' | 'consulting';
  priceFrom?: string; priceCurrency?: string; ratingValue?: string; reviewCount?: string;
  faqs?: { question: string; answer: string }[];
}

export function EnhancedServiceSchema({ serviceName, serviceDescription, serviceSlug, category, priceFrom = '3', priceCurrency = 'USD', ratingValue = '4.8', reviewCount = '127', faqs }: EnhancedServiceSchemaProps) {
  const { language } = useLanguage();
  const url = `${SITE_URL}/${language}/services/${category}/${serviceSlug}`;
  const schemas: object[] = [
    { '@context': 'https://schema.org', '@type': 'Service', '@id': `${url}#service`, name: serviceName, description: serviceDescription, url, provider: { '@type': 'Organization', '@id': `${SITE_URL}/#organization`, name: 'Call IT Dev' }, serviceType: serviceName, hasOfferCatalog: { '@type': 'OfferCatalog', name: `${serviceName} Plans`, itemListElement: [{ '@type': 'Offer', priceSpecification: { '@type': 'UnitPriceSpecification', price: priceFrom, priceCurrency, unitText: 'HOUR' }, availability: 'https://schema.org/InStock' }] }, aggregateRating: { '@type': 'AggregateRating', ratingValue, reviewCount, bestRating: '5' }, inLanguage: language, availableChannel: { '@type': 'ServiceChannel', serviceUrl: `${SITE_URL}/${language}/start`, servicePhone: BRAND.phone.main } },
  ];
  // FAQPage schema removed — service pages already inject FAQ via SEOHead jsonLd prop to avoid Google "Duplicate FAQPage" errors
  useSchemaDOM(schemas, `enhanced-service-${serviceSlug}`, [language, serviceName]);
  return null;
}
